import { render, staticRenderFns } from "./AxFileUpload.vue?vue&type=template&id=308aeff6&"
import script from "./AxFileUpload.vue?vue&type=script&lang=ts&"
export * from "./AxFileUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports